import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { DialogData } from '../open-dialog-add-edit-licence/open-dialog-add-edit-licence.component';
import { OpenDialogChooseImageFromClubComponent } from '../open-dialog-choose-image-from-club/open-dialog-choose-image-from-club.component';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { UiService } from 'app/shared/services/ui/ui.service';

@Component({
  selector: 'app-open-dialog-import-image',
  templateUrl: './open-dialog-import-image.component.html',
  styleUrls: ['./open-dialog-import-image.component.scss']
})
export class OpenDialogImportImageComponent extends SubscriptionBaseComponent implements OnInit {
  imageForm: UntypedFormGroup;
  images: any[] = [];
  imageSelected = null;
  file: any = null;

  isLoadingAllImages = false;

  color: ThemePalette = 'primary';

  constructor(
    public dialogRef: MatDialogRef<OpenDialogChooseImageFromClubComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: UntypedFormBuilder,
    private faIconService: FaiconService,
    private uiService: UiService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  initSub() {
    this.subscription.add(
    )
  }

  confirm(): void {
    this.dialogRef.close(this.file);
  }


  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  uploadImage(file: any): void {
    const limitSizeForImg = 300000;

    if (file[0].type !== 'image/jpeg' && file[0].type !== 'image/png') {
      this.uiService.showSnackbar(`Le fichier:  ${file[0].name} - n'est pas un format valide`);
    } else if (file[0].type === 'image/jpeg' || file[0].type === 'image/png' || file[0].type === 'image/jfif') {
      if (file[0].size > limitSizeForImg) {
        this.uiService.showSnackbar(`L'image:  ${file[0].name} est trop lourde (300kB max.)`);
      } else {
        this.file = file[0];
      }
    }

  }


}
